module.exports = __webpack_public_path__ + "static/img/200164.4722ba15.png";